export const firstTheme = {
  name: "first",
  colors: {
    honey: "#FFC600",
    mediumGray: "#1a1a1a",
    black: "#000",
    extraLightGray: "#666666",
    gray: "#A5A5A5",
    lightGray: "#4d4d4d",
    orange: "#FFB500",
    yellow: "#FFF200",
    gray100: "#F8F9FA",
    gray200: "#EBEDEF",
    gray300: "#9D9D9D",
    grayDark: "#343A40",
    red: "#E53935",
    redLight: "#feeaea",
    white: "#fff",
    purple: "#663399",
    purpleDark: "#452267",
    purpleLight: "#9945EE",
    blue: "#3300FF",
    green: "#00ba00",
    greenLight: "#ebfeea",
    greenDark: "#105710",
  },
};

export const secondTheme = {
  name: "second",
  colors: {
    honey: "#fff",
    black: "#fff",
    extraLightGray: "#666666",
    gray: "#A5A5A5",
    lightGray: "#4d4d4d",
    orange: "#FFB500",
    yellow: "#ADB5BD",
    gray100: "#EEEEEE",
    gray200: "#EBEDEF",
    gray300: "#9D9D9D",
    grayDark: "#343A40",
    red: "#E53935",
    redLight: "#feeaea",
    white: "#fff",
    purple: "#663399",
    purpleDark: "#452267",
    purpleLight: "#9945EE",
    blue: "#3300FF",
    green: "#00ba00",
    greenLight: "#ebfeea",
    greenDark: "#105710",
  },
};
